import { useEffect, useState } from 'react'
import { PromptDialog, type PromptSpec } from '../pos/PromptDialog'
import {
  getAutoPrint,
  getDeviceCode,
  getPrintAtTill,
  setPrintAtTill,
  onAutoPrintChange,
  setAutoPrint,
  setDeviceCode,
} from '../../utils/deviceId'

/**
 * Bu cihazın yazdırma ayarları: otomatik yazdırma ve kasa numarası.
 *
 * Ayarlar > Yazıcılar'da (patron) ve kasiyerin Yazıcılar sayfasında aynı
 * satırlar (20 Eki 2026). İkisi de yalnız bu tarayıcıda saklanıyor, kuruma
 * yazılmıyor: kasayı kuran kişi çoğu zaman kasiyer.
 */
export function DeviceRows() {
  const [autoPrint, setAutoPrintOn] = useState(getAutoPrint)
  const [device, setDevice] = useState(getDeviceCode)
  const [atTill, setAtTill] = useState(getPrintAtTill)
  const [prompt, setPrompt] = useState<PromptSpec | null>(null)

  // The same till with two tabs open would otherwise show the switch on in one
  // and off in the other, both writing the same key.
  useEffect(() => onAutoPrintChange(setAutoPrintOn), [])

  // Local, not saved to the yurt: two tills both left on "K1" would issue
  // duplicate receipt numbers.
  const onChangeDevice = () => {
    setPrompt({
      title: 'Kasa numarası',
      body: 'Fiş numarasının önüne gelir. Her kasa farklı olmalı: K1, K2, K3…',
      label: 'Bu cihazın kasa numarası',
      initial: device,
      onConfirm: (next) => setDevice(setDeviceCode(next)),
    })
  }

  return (
    <>
      <div className="setting">
        <div>
          <div className="setting__label">Otomatik yazdırma</div>
          <div className="setting__hint">Garson siparişleri bu bilgisayardan kendiliğinden basılır.</div>
        </div>
        <button
          type="button"
          className={`prn__switch ${autoPrint ? 'is-on' : ''}`}
          role="switch"
          aria-checked={autoPrint}
          aria-label="Otomatik yazdırma"
          onClick={() => {
            const next = !getAutoPrint()
            setAutoPrint(next)
            setAutoPrintOn(next)
          }}
        >
          <span />
        </button>
      </div>

      {/* Yazıcısız cihaz (21 Eki 2026): patronun bilgisayarı ya da yazıcısı
          olmayan ikinci kasa. Fişleri otomatik yazdırması açık kasa basar. */}
      <div className="setting">
        <div>
          <div className="setting__label">Fişleri kasa bilgisayarından bas</div>
          <div className="setting__hint">
            Bu bilgisayarda yazıcı yoksa açın. Buradaki satışların fişi, otomatik yazdırması açık kasa
            bilgisayarından çıkar.
          </div>
        </div>
        <button
          type="button"
          className={`prn__switch ${atTill ? 'is-on' : ''}`}
          role="switch"
          aria-checked={atTill}
          aria-label="Fişleri kasa bilgisayarından bas"
          onClick={() => {
            setPrintAtTill(!atTill)
            setAtTill(!atTill)
          }}
        >
          <span />
        </button>
      </div>

      <div className="setting">
        <div>
          <div className="setting__label">Kasa numarası</div>
          <div className="setting__hint">Fiş numaralarının önüne gelir (K1-0042). Her kasada farklı olmalı.</div>
        </div>
        <button type="button" onClick={onChangeDevice}>
          {device}
        </button>
      </div>

      {prompt && <PromptDialog {...prompt} onClose={() => setPrompt(null)} />}
    </>
  )
}
